module.exports = __webpack_public_path__ + "img/main_logo.2c285df5.png";